import React, { Component, Fragment } from 'react';
import { withTranslation, Trans } from "react-i18next";
import { Helmet } from "react-helmet";
import {
  GelContentContainer,
  HeroBlock,
  withRouter,
  ButtonSecondary,
  ApiPager,
  GelContentRow,
  GelContentColumn,
  Role,
  withFlashState, Link, CheckboxElement, Controls, withAuthentication, FormErrorSummary, Notices, withCoursePortalApi
} from "cw-styleguide-react";
import CoursesManageFilterForm from "../components/CoursesManageFilterForm";
import { route } from "../../../routes";
import withAssets from "../../../components/hoc/withAssets";
import qs from "qs";
import { ROLE_PROVIDER, ROLE_STAFF } from "../../../constants";

class CoursesManageView extends Component {

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.clearRedirect();
  }

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('local:view.courses.manage.title')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.t('local:view.courses.manage.title')}</h1>
        </GelContentContainer>
        <HeroBlock>
          <Role roles={[ROLE_STAFF]}>
            {this.props.t('local:view.courses.manage.introduction.staff')}
          </Role>
          <Role roles={[ROLE_PROVIDER]}>
            {this.props.t('local:view.courses.manage.introduction.provider')}
          </Role>
        </HeroBlock>

        <GelContentContainer>



          <Notices messages={this.props.messages} />
          <FormErrorSummary errors={this.props.formErrors} />

          <Controls>
            <ButtonSecondary url={route('coursesCreate')} title={this.props.t('local:view.courses.manage.controls.create')}>{this.props.t('local:view.courses.manage.controls.create')}</ButtonSecondary>
            <ButtonSecondary disabled={!this.props.selected.size} onClick={() => { this.props.toggleModal(['bulkDelete'], true) }} title={this.props.t('local:view.courses.manage.controls.delete')}>{this.props.t('local:view.courses.manage.controls.delete')}</ButtonSecondary>
            <ButtonSecondary disabled={!this.props.selected.size} onClick={() => { this.props.toggleModal(['bulkArchive'], true) }} title={this.props.t('local:view.courses.manage.controls.archive')}>{this.props.t('local:view.courses.manage.controls.archive')}</ButtonSecondary>
            <ButtonSecondary disabled={!this.props.selected.size} onClick={() => { this.props.toggleModal(['bulkRollback'], true) }} title={this.props.t('local:view.courses.manage.controls.rollback')}>{this.props.t('local:view.courses.manage.controls.rollback')}</ButtonSecondary>
            <Role roles={[ROLE_STAFF]}>
              <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {
                this.props.navigate(route('coursesUpdateBySelected') + "?" + qs.stringify({ courses: [...this.props.selected] }));
              }} title={this.props.t('local:view.courses.manage.controls.massUpdate')}>{this.props.t('local:view.courses.manage.controls.massUpdate')}</ButtonSecondary>
            </Role>
          </Controls>

          <GelContentRow>
            <GelContentColumn xs={12} sm={12} md={4} lg={4} mdPush={8} lgPush={8}>
              <CoursesManageFilterForm values={this.props.filterValues} handleChange={this.props.handleChange} handleSubmit={this.props.handleSubmit} handleReset={this.props.handleReset} />
            </GelContentColumn>
            <GelContentColumn xs={12} sm={12} md={8} lg={8} mdPull={4} lgPull={4}>

              <ApiPager
                authorize={true}
                api={this.props.coursePortalApiGetEndpoint('course_portal_api_course_q')}
                filters={{
                  courseId: this.props.filterValues.courseId,
                  courseTitle: this.props.filterValues.courseTitle,
                  statuses: this.props.filterValues.courseStatus,
                  courseGroupType: this.props.filterValues.courseGroupType,
                  courseGroupId: this.props.filterValues.courseGroupId,
                  reviewDate: this.props.filterValues.courseReviewDate,
                  mainProvider: this.props.filterValues.mainProviderId,
                }}
                autoReload={false}
                sortOptions={[
                  {
                    value: 'rel',
                    label: this.props.t('styleguide:forms.order.options.rel')
                  },
                  {
                    value: 'titleAsc',
                    label: this.props.t('styleguide:forms.order.options.asc')
                  },
                  {
                    value: 'titleDesc',
                    label: this.props.t('styleguide:forms.order.options.desc')
                  },
                  {
                    value: 'dateAsc',
                    label: this.props.t('local:view.courses.manage.order.dateAsc')
                  },
                  {
                    value: 'dateDesc',
                    label: this.props.t('local:view.courses.manage.order.dateDesc')
                  }

                ]}
                initialOrder={this.props.filterValues['order']}
                initialPage={this.props.filterValues['page']}
                initialGroupSize={this.props.filterValues['groupSize']}
                handleStateChange={this.props.handleStateChange}
                reloadKey={this.props.reloadKey}
                onReloadResetPage={true}
                noResultsText={this.props.t('styleguide:messages.noResults')}
                hasResultsText={''}
                table={true}
                // tableCaption={''}
                // tableHideCaption={true}
                tableIsSelectable={true}
                tableHeader={(data) => (
                  <tr>
                    <th>
                      <CheckboxElement
                        label={
                          <Trans i18nKey={'local:view.courses.manage.tableHeader.select'}>
                            <span className='visually-hidden' />
                          </Trans>
                        }
                        checked={this.props.selected.size === data.length}
                        value={''}
                        onChange={(e) => this.props.handleSelectAll(data.map(course => course.courseId))}
                      />
                    </th>
                    <th>{this.props.t('local:view.courses.manage.tableHeader.id')}</th>
                    <th>{this.props.t('local:view.courses.manage.tableHeader.title')}</th>
                    <th>{this.props.t('local:view.courses.manage.tableHeader.type')}</th>
                    <th>{this.props.t('local:view.courses.manage.tableHeader.status')}</th>
                  </tr>
                )}
                render={(course) => (<tr>
                  <td><CheckboxElement onChange={this.props.handleBulkCheckbox} checked={this.props.selected.has(course.courseId)} value={course.courseId} /></td>
                  <td>{course.courseId}</td>
                  <td><Link to={route('coursesEdit', { "course": course.courseId })}>{course.title}</Link></td>
                  <td>{this.props.courses.assets.courseGroups.courseGroupTypeLookup[course.courseGroupType]}</td>
                  <td>{this.props.courses.getStatusName(course.status)}</td>
                </tr>)} />
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withCoursePortalApi(process.env)(withAuthentication(withRouter(withAssets(withFlashState(withTranslation('local')(CoursesManageView))))));
